module.exports = __webpack_public_path__ + "static/top_content-5dc950d33400c5aa2ed0454f3b99d2d3.png";